import React, { useState } from "react";
import { Option } from "react-select/lib/filters";
import { useTranslation } from "react-i18next";
import useGetDepartmentOptions from "@modules/shared/selectors/hooks/useGetDepartmentOptions";
import AdvanceSelector from "../advance-selector";

interface AdvancedDepartmentSelectorProps {
  onChange?: (option: Option) => void;
  departmentOption?: Option;
  scenario: string;
}

const AdvancedDepartmentSelector = ({
  scenario,
  onChange,
  departmentOption,
}: AdvancedDepartmentSelectorProps) => {
  const [value, setValue] = useState(departmentOption);

  const { loadOptions } = useGetDepartmentOptions({
    scenario,
  });

  const { t } = useTranslation();

  return (
    <AdvanceSelector
      isPaginated
      dimension={t("advanced-search.instructor.forms.select-wrapper.school.label")}
      selectPlaceholder={t("advanced-search.instructor.forms.select-wrapper.school.placeholder")}
      loadOptions={loadOptions}
      value={value}
      onChange={option => {
        setValue(option);
        onChange?.(option);
      }}
      notShowLabel
    />
  );
};

export default AdvancedDepartmentSelector;
